module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_lilac_Front_30.707ccd23.png";